import { ForgottenPasswordComplete } from "./ForgottenPasswordComplete";

export default ForgottenPasswordComplete;
